module.exports = __webpack_public_path__ + "static/media/GreenArea.f83b99e9.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Videos/GreenArea.mp4
// module id = 7510
// module chunks = 0